const reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
const reHasRegExpChar = RegExp(reRegExpChar.source);

/**
 * Prepares string for using within a RegExp by escaping special characters
 *
 * @param {string} string
 * @returns {string}
 */
export const regExpEscape = (string: string): string => {
    return string && reHasRegExpChar.test(string)
        ? string.replace(reRegExpChar, "\\$&")
        : string;
};
